/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseHeaderFragment} from '@amblique/contentful/app/contentful/fragments/header/base-header.fragment';
import {BaseImageFragment} from '@amblique/contentful/app/contentful/fragments/image/base-image.fragment';
import {BaseLinkFragment} from '@amblique/contentful/app/contentful/fragments/link/base-link.fragment';
import {BaseNavigationMenuFragment} from '@amblique/contentful/app/contentful/fragments/navigation-menu/base-navigation-menu.fragment';
import {BaseRichTextBlockFragment} from '@amblique/contentful/app/contentful/fragments/rich-text-block/base-rich-text-block.fragment';
import {BaseSectionPanelFragment} from '@amblique/contentful/app/contentful/fragments/section-panel/base-section-panel.fragment';

export const HeaderFragment = gql`
  ${BaseHeaderFragment}
  ${BaseImageFragment}
  ${BaseLinkFragment}
  ${BaseNavigationMenuFragment}
  ${BaseRichTextBlockFragment}
  ${BaseSectionPanelFragment}

  fragment HeaderFragment on Header {
    ...BaseHeaderFragment

    logo {
      ...BaseImageFragment
    }
    mainNavigation {
      ...BaseNavigationMenuFragment
    }
    promoBannersCollection {
      items {
        __typename
        ... on RichTextBlock {
          ...BaseRichTextBlockFragment
        }
        ... on SectionPanel {
          ...BaseSectionPanelFragment
        }
      }
    }
    utilityLinksCollection {
      items {
        __typename
        ... on Link {
          ...BaseLinkFragment
        }
      }
    }
  }
`;
